import { render, staticRenderFns } from "./EnergyLabel.vue?vue&type=template&id=72cc63fa&scoped=true&"
import script from "./EnergyLabel.vue?vue&type=script&lang=js&"
export * from "./EnergyLabel.vue?vue&type=script&lang=js&"
import style0 from "./EnergyLabel.vue?vue&type=style&index=0&id=72cc63fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc63fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72cc63fa')) {
      api.createRecord('72cc63fa', component.options)
    } else {
      api.reload('72cc63fa', component.options)
    }
    module.hot.accept("./EnergyLabel.vue?vue&type=template&id=72cc63fa&scoped=true&", function () {
      api.rerender('72cc63fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/EnergyLabel.vue"
export default component.exports